<Loader :loading="loading" />
<HomeNavBar />

<!-- Services Section -->
<div class="row">
  <!-- Sidebar -->
  <div class="col-lg-2 d-lg-block h-100">
    <MenuSideBar />
  </div>

  <!-- Main Content -->
  <div class="col-lg-10 p-2 scrollable-container">
    <!-- Create Button -->
    <div class="mb-4">
      <button
      v-can-create="'services'"
      class="fab border-0 shadow mx-5 mt-4"
      data-bs-toggle="modal"
      data-bs-target="#create_service_modal"
    >
      +
    </button>
    </div>

    <!-- Add your services list here -->
    <div class="event-group mx-5">
        <div class="d-flex align-items-center temporary-post" v-if="isLoading" id="temp-post">
          <p class="text-xs fw-bold">Loading...</p>
          <div class="spinner-border ms-auto text-secondary" role="status" aria-hidden="true"></div>
        </div>

        <div v-for="service in services" :key="service.id" class="card border-0 shadow-sm mt-2">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start">
                <div>
                  <h5 class="card-title fw-bold">{{ service.name }}</h5>
                  <p class="text-muted text-xs">{{ service.description }}</p>
                </div>
                <div class="d-flex align-items-center">
                  <span class="badge bg-success me-2" v-if="service.is_available">Available</span>
                  <span class="badge bg-danger me-2" v-else>Unavailable</span>
                  <div class="dropend" @click.stop>
                    <a href="" class="fw-bold text-dark" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="bi bi-three-dots-vertical"></i>
                    </a>
                    <ul class="dropdown-menu custom-dropdown lh-1" aria-labelledby="dropdownMenuButton">
                      <li v-if="current_role === 'admin' || service.base_profile?.creater === current_user_id">
                        <a class="dropdown-item text-xs fw-bold" href="" @click.prevent="edit_service(service)">
                          <i class="bx bxs-edit fs-6"></i> Edit
                        </a>
                      </li>
                      <li v-else>
                        <a class="dropdown-item text-xs fw-bold text-danger" href="#" @click.prevent="not_allowed_alert()">
                          <i class="bi bi-exclamation-triangle"></i> Not allowed
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            <p class="text-muted text-xs">
              <i class="bi bi-person text-muted"></i> {{ service.base_profile?.profile_name }}
            </p>
            <p class="text-muted text-xs">
              <i class="bi bi-telephone text-muted"></i> {{ service.phone_number }}
            </p>
            <div class="d-flex align-items-center">
                <button class="btn btn-primary text-xs me-2" :disabled="!service.is_available">
                    Request Service
                </button>
                <button v-if="current_role === 'admin' || service.base_profile?.creater === current_user_id"
                :class="service.is_available ? 'btn btn-danger text-xs' : 'btn btn-success text-xs'"
                @click="toggle_service_availability(service)">
            {{ service.is_available ? 'Mark Unavailable' : 'Mark Available' }}
        </button>
        </div>
          </div>
        </div>
      </div>

<!-- Create Service Modal -->
<div
  class="modal fade"
  id="create_service_modal"
  tabindex="-1"
  aria-labelledby="createServiceLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h6 class="modal-title fw-bold" id="createServiceLabel">
          Create Service
        </h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <form @submit.prevent="create_service">
        <div class="modal-body">
          <div class="mb-3">
            <label for="service_name" class="form-label text-xs fw-500">Service Name<span class="text-danger">*</span></label>
            <input
              type="text"
              id="service_name"
              class="form-control rounded-5 text-xs"
              v-model="service_name"
              required
            />
          </div>

          <div class="mb-3">
            <label for="description" class="form-label text-xs fw-500">Description</label>
            <textarea
              id="description"
              class="form-control rounded-5 text-xs"
              rows="3"
              v-model="description"
            ></textarea>
          </div>

          <div class="mb-3">
            <label for="phone_number" class="form-label text-xs fw-500">Whatsapp Number<span class="text-danger">*</span></label>
            <input
              type="text"
              id="phone_number"
              class="form-control rounded-5 text-xs"
              v-model="phone_number"
              required
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="submit"
            class="btn btn-primary rounded-5"
            :disabled="isSubmitting"
          >
            {{ isSubmitting ? 'Creating...' : 'Save Service' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
  </div>
</div>

<div class="modal fade" id="editServiceModal" tabindex="-1" aria-labelledby="editServiceModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="editServiceModalLabel">Edit Service</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="mb-3">
              <label for="serviceName" class="form-label">Service Name</label>
              <input type="text" class="form-control" id="serviceName" v-model="selected_service.name">
            </div>
            <div class="mb-3">
              <label for="serviceDescription" class="form-label">Service Description</label>
              <textarea class="form-control" id="serviceDescription" v-model="selected_service.description"></textarea>
            </div>
            <div class="mb-3">
              <label for="servicePhoneNumber" class="form-label">Service Phone Number</label>
              <input type="text" class="form-control" id="servicePhoneNumber" v-model="selected_service.phone_number">
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="update_service(selected_service)">Save changes</button>
        </div>
      </div>
    </div>
  </div>
